import { FC, PropsWithChildren } from 'react';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import LoaderOverlay from '@/components/ui/LoaderOverlay/LoaderOverlay.tsx';

type ImageBackgroundProps = PropsWithChildren<
  PropsWithClassName<{
    src?: string;
    dark?: boolean;
    isLoading?: boolean;
  }>
>;

const ImageBackground: FC<ImageBackgroundProps> = ({
  src = undefined,
  children,
  className,
  dark = false,
  isLoading = false,
}) => {
  return (
    <div
      className={cn('flex flex-col justify-end relative', className)}
      style={{ backgroundImage: `url(${src})`, backgroundSize: 'cover', backgroundPosition: 'center 30%' }}
    >
      {isLoading && (
        <LoaderOverlay isLoading={isLoading} className="absolute inset-0" loaderClassName="bg-opacity-50" />
      )}
      <div
        className={cn(
          'min-h-[60px] flex flex-col justify-end bg-gradient-to-b from-transparent pt-4 rounded-b-[inherit] z-10',
          {
            'to-journi-theme-light': !dark,
            'to-black': dark,
          }
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default ImageBackground;
